import React from "react";
import TopBar from "./components/TopBar";
import LinkNav from "./components/LinkNav";

import { useUser } from "./../../../contexts/UserContext";
import { useClubSettings } from "./hooks/useClubSettings";
import { useNavbarUserBootstrap } from "./hooks/useNavbarUserBootstrap";

const Navbar2 = () => {
  const { user, updateUser } = useUser();
  const { settings, loading: settingsLoading } = useClubSettings();

  useNavbarUserBootstrap({ user, updateUser });

  const onLogout = () => {
    localStorage.clear();
    updateUser(null);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-[999] w-full overflow-x-clip">
      <TopBar user={user} settings={settings} onLogout={onLogout} />

      <LinkNav
        user={user}
        settings={settings}
        settingsLoading={settingsLoading}
      />
    </header>
  );
};

export default Navbar2;